import { ModulesMap, ModulesConfigMap, MockMethodsMap } from '@/config/data/modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.CACHE].GET_CACHE_HASHES]: {
		mock: false,
		mockMethodName: MockMethodsMap[ModulesMap.CACHE].GET_CACHE_HASHES,
		url: '/companies/:companyId/versions/',
	},
}
